"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetsProvider = exports.useAssetsPath = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const AssetsContext = (0, react_1.createContext)('/static');
function useAssetsPath(...pathParts) {
    const contextPath = (0, react_1.useContext)(AssetsContext);
    return [contextPath, ...pathParts.filter(Boolean)].join('/');
}
exports.useAssetsPath = useAssetsPath;
function AssetsProvider({ path, children, }) {
    return ((0, jsx_runtime_1.jsx)(AssetsContext.Provider, Object.assign({ value: path }, { children: children })));
}
exports.AssetsProvider = AssetsProvider;
